const navigationConfig = [
  {
    id: 'Main',
    title: '',
    type: 'group',
    children: [
      {
        id: 'notice',
        title: 'Notice',
        type: 'item',
        icon: 'notification',
        url: '/pages/notice',
        exact: true,
      },
      {
        id: 'hospital',
        title: 'Hospital',
        type: 'item',
        icon: 'database',
        url: '/pages/hospital',
        exact: true,
      },
      {
        id: 'recDoctor',
        title: 'Doctor',
        type: 'item',
        icon: 'idcard',
        url: '/pages/recDoctor',
        exact: true,
      },
      {
        id: 'product',
        title: 'Product',
        type: 'item',
        icon: 'shopping',
        url: '/pages/product',
        exact: true,
      },
      // {
      //   id: 'news',
      //   title: 'News & Column',
      //   type: 'item',
      //   icon: 'file_text',
      //   url: '/pages/news',
      //   exact: true,
      // },
      {
        id: 'news',
        title: 'News & Column',
        type: 'collapse',
        icon: 'file_text',
        children: [
          {
            id: 'newsNews',
            title: 'News',
            type: 'item',
            url: '/pages/news/news',
            exact: false,
          },
          {
            id: 'newsColumn',
            title: 'Column',
            type: 'item',
            url: '/pages/news/column',
            exact: false,
          },
          {
            id: 'newsTourInfo',
            title: 'Tour Information',
            type: 'item',
            url: '/pages/news/tourInfo',
            exact: false,
          },
        ],
      },
    ],
  },
];

export default navigationConfig;
